import {
  FlexBox,
  JoonUIColor,
  SPACING,
  Typography,
  UserRole,
} from "@joonapp/web-shared"
import {
  createColumnHelper,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table"
import dayjs from "dayjs"
import { useMemo, useState } from "react"

import CustomTable from "../../components/table/CustomTable"
import TableHeaderCell from "../../components/table/TableHeaderCell"
import { useCoachingGroupsQuery } from "../../networking/coachingGroups/queries"
import { CoachingGroup } from "../../types"

const ClientManagement = () => {
  return (
    <FlexBox direction="column" wrap={false} gap={SPACING.space4}>
      <Typography variant="h3">Clients</Typography>
      <FlexBox
        justify="space-between"
        align="center"
        gap={SPACING.space2}
        wrap={false}
        style={{
          padding: SPACING.space4,
          border: `1px solid ${JoonUIColor.border.default}`,
          borderRadius: SPACING.space2,
          background: JoonUIColor.background.primaryNeutral,
        }}
      >
        <ClientManagementTable />
      </FlexBox>
    </FlexBox>
  )
}

export default ClientManagement

const columnHelper = createColumnHelper<CoachingGroup>()

const ClientManagementTable = () => {
  const { data: coachingGroups } = useCoachingGroupsQuery()

  const [sorting, setSorting] = useState([{ id: "Date added", desc: true }])
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })
  const [hoveredRowId, setHoveredRowId] = useState<string | null>(null)

  const tableData = useMemo(() => coachingGroups || [], [coachingGroups])

  const createColumns = () => [
    columnHelper.accessor(
      (row) =>
        row.profiles.find((p) => p.role === UserRole.CLIENT)?.user.name ||
        "N/A",
      {
        id: "Client name",
        cell: (info) => (
          <Typography variant="bodySmall">{info.getValue()}</Typography>
        ),
        header: () => <TableHeaderCell>Client name</TableHeaderCell>,
        size: 150,
      }
    ),
    columnHelper.accessor((row) => row.date_created, {
      id: "Date added",
      cell: (info) => (
        <Typography variant="bodySmall">
          {dayjs(info.getValue()).format("MMM D, YYYY")}
        </Typography>
      ),
      header: () => <TableHeaderCell>Date Added</TableHeaderCell>,
      size: 200,
    }),
  ]

  const table = useReactTable({
    data: tableData,
    columns: createColumns(),
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
    state: { sorting, pagination },
  })

  // if (isLoadingClients) return <PageLoader />

  // if (tableData.length === 0) {
  //   return <ClientManagementEmptyState />
  // }

  return (
    <CustomTable
      table={table}
      hoveredRowId={hoveredRowId}
      setHoveredRowId={setHoveredRowId}
    />
  )
}
